import { render } from "./EmailItem.vue?vue&type=template&id=5779bf4a&scoped=true&lang=true"
import script from "./EmailItem.vue?vue&type=script&lang=js"
export * from "./EmailItem.vue?vue&type=script&lang=js"

import "./EmailItem.vue?vue&type=style&index=0&id=5779bf4a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5779bf4a"]])

export default __exports__